module.exports = __webpack_public_path__ + "img/angela-sung-tramline.7f3bd6b.jpg";